export function slugifyText(text: string) {
    return text.toLowerCase().replace(/\s+/g, '-')
}

export function formatPrice(price: number, options?: { trimZeros?: boolean }) {
    const isRound = Number.isFinite(price) && Math.abs(price - Math.round(price)) < 1e-9
    const fractionDigits = options?.trimZeros && isRound ? 0 : 2
    return price.toLocaleString('bg', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }) + ' €'
}

export function getImageUrl(url: string) {
  const config = useRuntimeConfig()
  const baseURL = (config.public.apiBaseUrl as string).replace(/\/$/, '');
  return url.replace('/api/w4eshop', baseURL)
}
